import Vue from 'vue';
export default Vue.extend({
    name: 'queryCondition',
    props: {
        queryConditionConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        size: {
            type: String,
            default: 'small',
        },
        isInline: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            ruleForm: {},
        };
    },
    created: function () {
        this.init();
    },
    methods: {
        // 初始化默认选中值
        init: function (isResetForm) {
            if (isResetForm === void 0) { isResetForm = false; }
            var initSearch = {};
            this.queryConditionConfig.forEach(function (item) {
                var isRouteParam = item.isRouteParam, defaultValue = item.defaultValue;
                if (!(isRouteParam && isResetForm) && defaultValue !== undefined) {
                    initSearch[item.key] = defaultValue;
                }
            });
            this.ruleForm = Object.assign({}, initSearch);
        },
        submitForm: function () {
            this.$emit('get-query-condition', Object.assign({}, this.ruleForm));
        },
        resetForm: function () {
            this.ruleForm = {};
            this.init(true);
            this.submitForm();
        },
        clearHandler: function (config) {
            config.clearCallback && config.clearCallback();
        },
    },
});
